import rwLogoSvg from "../assets/images/RW_Logo_SVG.svg";

let cachedLogoPng = null;

/**
 * Loads the RW Market Intelligence SVG logo and rasterizes it to a crisp
 * high-resolution PNG data URL for jsPDF invoice generation.
 */
export const getRwLogoPng = async () => {
  if (cachedLogoPng) return cachedLogoPng;

  return new Promise((resolve) => {
    try {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          const scale = 3; // 3x DPI for crisp PDF printing
          canvas.width = (img.naturalWidth || 327) * scale;
          canvas.height = (img.naturalHeight || 193) * scale;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          cachedLogoPng = canvas.toDataURL("image/png");
          resolve(cachedLogoPng);
        } catch (err) {
          console.warn("Could not export logo canvas:", err);
          resolve(null);
        }
      };
      img.onerror = () => {
        console.warn("Failed to load logo SVG image");
        resolve(null);
      };
      img.src = rwLogoSvg;
    } catch (e) {
      resolve(null);
    }
  });
};
